export default __webpack_public_path__ + "static/media/avater1.6a65813c.png";